const defaultTitle = '宜泊停车';

export default {
  namespace: 'app',
  state: {
    title: defaultTitle
  },
  actions: {
    setTitle(state, { title }) {
      const displayTitle = title ? `${title}-${defaultTitle}` : defaultTitle;
      if (document.title) {
        window.document.title = displayTitle;
      }
      return { ...state, title: displayTitle };
    }
  }
};
